import styled from 'styled-components';

export const MeasurementContainer = styled.div`
    .measurement_sections{
        position: relative;
        left: 10px;
        top: 56px;
    }
    .measurement_sections .ant-card {
        background-color:#33363C !important;
        color: #ffffff !important;
        box-shadow: none;
    }
    .measurement_sections .ant-card-body {
        padding: 8px;
    }
    .measurement_sections .measurement_addButton {
        background-color: #33363C;
        color: #ffffff;
        font-size: 14px;
        border-top: 1px solid #6A727C;
        width: 100%;
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 10px 0px;
        cursor: pointer;
    }
    .measurement_addButton.no-border-top {
        border-top: none;
    }
    .measurement_sections .measurement_addButton:hover {
        color: #36BDBE !important;
    }
    .measurement_sections .measurement_addButton:hover svg path{
        stroke: #36BDBE !important;
    }
    .measurement_sections  button:focus {
        outline: unset;
        outline: unset;
    }
`;